// extracted by mini-css-extract-plugin
export var cell = "_4r-4";
export var headerCell = "_4r-2";
export var rowHeader = "_4r-3";
export var table = "_4r-1";
export var tableContainer = "_4r-0";